export default "__VITE_ASSET__DanvwP0F__"